import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import { DataGrid, esES } from '@mui/x-data-grid';
import { setDashboardNodeSelected } from '../../../store/fuse/dashboard';
import {NODE_STATES} from "../utils";

const columns = [
  {
    field: 'statusPercentage',
    headerName: 'Estatus',
    sortable: true,
    align: 'left',
    renderCell: (params) => {
      const value = Math.trunc(Number(params.row?.statusPercentage));
      return (
        <Box display="flex" flexDirection="row" alignItems="center" sx={{ width: '100%' }}>
          {Number(value) === 100 ? (
            <div
              role="button"
              aria-label="green-indicator-btn"
              className="rounded-header-section"
              tabIndex={0}
              style={{ background: NODE_STATES[2] }}
            />
          ) : (
            <div
              role="button"
              aria-label="red-indicator-btn"
              className="rounded-header-section"
              tabIndex={0}
              style={{ background: NODE_STATES[0] }}
            />
          )}
        </Box>
      );
    },
  },
  {
    field: 'dsNodo',
    headerName: 'Nodo',
    width: 250,
    flex: 1,
  },
  {
    field: 'duracionStatus',
    headerName: 'Tiempo',
    sortable: true,
    flex: 1,
  },
  {
    field: 'fechaMovimiento',
    headerName: 'Fecha Evento',
    sortable: true,
    flex: 1,
  },
];

const CaidasNodos = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const caidasData = useSelector((state) => state?.fuse?.dashboard?.dashboard?.caidasNodes);
  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);

  const handleRowClick = (row) => {
    dispatch(setDashboardNodeSelected('/dashboard', row.row.dsNodo));
    navigate(`/dashboard/${row.row.nodoId}`);
  };

  return (
    <div
      className="flex max-w-full gap-0 m-10 rounded-lg flex-col"
      style={{ height: '700px', backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'white' }}
    >
      <strong className="title-chart">Log General de la Red</strong>
      <Box display="flex" justifyContent="center" alignItems="center" sx={{ height: 680, width: '100%', marginTop: '20px' }}>
        <DataGrid
          localeText={{
            ...esES.components.MuiDataGrid.defaultProps.localeText,
            noRowsLabel: 'No hay registros', 
          }}
          rows={caidasData}
          columns={columns}
          disableRowSelectionOnClick
          onRowClick={handleRowClick}
          sortModel={[{ field: 'fechaMovimiento', sort: 'desc' }]}
        />
      </Box>
    </div>
  );
};

export default CaidasNodos;
